module.exports = __webpack_public_path__ + "static/media/darkChat.d1fd032c.svg";